import { render, staticRenderFns } from "./GreenBudgetDetailsForm.vue?vue&type=template&id=e038c564&"
import script from "./GreenBudgetDetailsForm.vue?vue&type=script&lang=js&"
export * from "./GreenBudgetDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports